module.exports = __webpack_public_path__ + "img/group23-ct.c566132e.png";